import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
const Card: React.FC<CardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 ${className}`} data-id="element-272">
      {children}
    </div>;
};
export const CardHeader: React.FC<CardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`px-6 py-4 border-b border-gray-100 ${className}`} data-id="element-273">
      {children}
    </div>;
};
export const CardBody: React.FC<CardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`${className}`} data-id="element-274">{children}</div>;
};
export const CardFooter: React.FC<CardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`px-6 py-4 border-t border-gray-100 ${className}`} data-id="element-275">
      {children}
    </div>;
};
export default Card;